export const BROWSER_COOKIE_ID = 'BrowserCookieId';
export const CARVANA_DEVICE_ID = 'carvanaDeviceId';

export const CHAT_UI_PREFIX = 'chat-ui';
export const CHAT_UI_SHADOW_ROOT = `${CHAT_UI_PREFIX}-shadow-root`;

export const MESSAGES_LIST_BOTTOM_SPACER_ID = 'messages-list-bottom-spacer';
export const QUESTION_INPUT_FIELD_ID = 'text-input-question-field';

export const IDENTIFY_TYPES = {
  BROWSER_COOKIE_ID,
  CARVANA_DEVICE_ID,
} as const;

type Keys = keyof typeof IDENTIFY_TYPES;
type Values = (typeof IDENTIFY_TYPES)[Keys];

export type IDENTIFY_TYPE = Values;
